import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core'; import { Observable } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class InteroperabilityService {
    accountChanged: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    $accountChanged: Observable<any> = this.accountChanged.asObservable();
}

